import { atom } from "recoil"

export const mobilePurchaseJustCompletedAtom = atom<boolean>({
  key: "mobilePurchaseJustCompletedAtom",
  default: false,
})
